import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../Config";
import { Snackbar, Alert as MuiAlert } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./ProjectActionButtons.css";
import axiosInstance from "../axiosinstance";
import {
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { OutlinedInput } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { X } from "lucide-react";
import EquipmentGroupSelect from "./EquipmentGroupSelect";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ProjectForm({ isSidebarExpanded }) {
  const [formData, setFormData] = useState({
    name: "",
    UnitName: "",
    Description: "",
    StartDate: "",
    EndDate: "",
    work_order_id: "",
    client_code: "",
    client_name: "",
    client_id: "",
    location: "",
    timezone: "",
    project_code: "",
    rating_config: [
      {
        rating_value: "",
        type: "",
        color_code: "#000000",
      },
    ],
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [clientCode, setclientCode] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [users, setUsers] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [accessWindowSearch, setAccessWindowSearch] = useState("");
  const [hoveredUserId, setHoveredUserId] = useState(null);
  const [equipmentGroupOptions, setEquipmentGroupOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [fieldErrors, setFieldErrors] = useState({});

  // New state for user access windows
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userAccessWindows, setUserAccessWindows] = useState([]);
  const fieldRefs = useRef({});

  const navigate = useNavigate();

  console.log("clinent code state =", clientCode);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axiosInstance.get("/api/get_users_for_dropdown");
        const normalizedUsers = (res.data?.user_data || []).map((user) => ({
          ...user,
          users_name: user.user_name || "",
        }));
        setUsers(normalizedUsers);
      } catch (err) {
        console.error("Error fetching users", err);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchClientCode = async () => {
      setIsLoading(true);
      try {
        // ✅ Remove manual Authorization header
        const res = await axiosInstance.get("/api/get_client_code");
        const clientCodeData = Array.isArray(res.data?.data)
          ? res.data.data
          : [];
        setclientCode(clientCodeData);
      } catch (error) {
        console.log("error in get client code =", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchClientCode();
  }, []);

  useEffect(() => {
    const fetchEquipmentGroups = async () => {
      try {
        const res = await axiosInstance.get(`${API_URL}/api/get_all_equipment_groups`);
        const options = (res?.data?.data || []).map((item) => ({
          value: item.id,
          label: `${item.equipment_group_code || ""} - ${item.equipment_group_name || ""}`.trim(),
        }));
        setEquipmentGroupOptions(options);
      } catch (err) {
        console.error("Error fetching equipment groups", err);
      }
    };
    fetchEquipmentGroups();
  }, []);
   const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setFieldErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const setFieldRef = (name) => (element) => {
    if (element) fieldRefs.current[name] = element;
  };

  const scrollToFirstInvalidField = (fieldName) => {
    const element = fieldRefs.current[fieldName];
    if (!element) return;
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    const focusTarget =
      element.matches("input, select, textarea, button, [role='combobox']")
        ? element
        : element.querySelector(
            "input, select, textarea, button, [role='combobox']",
          );
    if (focusTarget?.focus) {
      setTimeout(() => focusTarget.focus(), 150);
    }
  };

  const validateRequiredFields = () => {
    const errors = {};

    if (!formData.name?.trim()) errors.name = "Name of Project is required";
    if (!formData.client_code?.trim())
      errors.client_code = "Client Code is required";
    if (!formData.client_name?.trim())
      errors.client_name = "Client Name is required";
    if (!formData.timezone?.trim()) errors.timezone = "Timezone is required";
    if (!formData.project_code?.trim())
      errors.project_code = "Project Code is required";
    if (!formData.work_order_id?.trim())
      errors.work_order_id = "Work Order ID is required";
    if (!formData.UnitName?.trim()) errors.UnitName = "Unit Name is required";
    if (!startDate) errors.startDate = "Project Start Date is required";
    if (!endDate) errors.endDate = "Project End Date is required";
    setFieldErrors(errors);
    const firstInvalidField = Object.keys(errors)[0];
    if (firstInvalidField) {
      scrollToFirstInvalidField(firstInvalidField);
      setSnackbarMessage(errors[firstInvalidField] || "Missing required fields.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return false;
    }
    return true;
  };

  // Handle user selection
  // const handleUserSelection = (userId) => {
  //   const isSelected = selectedUsers.includes(userId);

  //   if (isSelected) {
  //     // Deselect user
  //     setSelectedUsers(selectedUsers.filter(id => id !== userId));
  //     setUserAccessWindows(userAccessWindows.filter(window => window.user_id !== userId));
  //   } else {
  //     // Select user
  //     setSelectedUsers([...selectedUsers, userId]);
  //     // Add access window with default dates (today and one month later)
  //     const today = new Date();
  //     const oneMonthLater = new Date();
  //     oneMonthLater.setMonth(today.getMonth() + 1);

  //     setUserAccessWindows([
  //       ...userAccessWindows,
  //       {
  //         user_id: userId,
  //         access_start: today,
  //         access_end: oneMonthLater
  //       }
  //     ]);
  //   }
  // };

  const handleUserSelection = (userId) => {
    const isSelected = selectedUsers.includes(userId);

    if (isSelected) {
      // Deselect user
      setSelectedUsers(selectedUsers.filter((id) => id !== userId));
      setUserAccessWindows(
        userAccessWindows.filter((window) => window.user_id !== userId),
      );
    } else {
      // Select user
      setSelectedUsers([...selectedUsers, userId]);
      setFieldErrors((prev) => ({ ...prev, selectedUsers: "" }));
      // Add access window with project start and end dates
      setUserAccessWindows([
        ...userAccessWindows,
        {
          user_id: userId,
          access_start: startDate,
          access_end: endDate,
          equipment_group_ids: [],
        },
      ]);
    }
  };

  // Update access window dates
  const handleAccessWindowDateChange = (userId, field, date) => {
    setUserAccessWindows(
      userAccessWindows.map((window) =>
        window.user_id === userId ? { ...window, [field]: date } : window,
      ),
    );
  };

  const handleUserEquipmentGroupsChange = (userId, groupIds) => {
    setUserAccessWindows(
      userAccessWindows.map((window) =>
        window.user_id === userId
          ? { ...window, equipment_group_ids: Array.isArray(groupIds) ? groupIds : [] }
          : window,
      ),
    );
  };

  // Remove user from access windows
  const handleRemoveUser = (userId) => {
    setSelectedUsers(selectedUsers.filter((id) => id !== userId));
    setUserAccessWindows(
      userAccessWindows.filter((window) => window.user_id !== userId),
    );
  };

  const getUserProjectText = (user) => {
    const projects = Array.isArray(user?.assigned_projects)
      ? user.assigned_projects
      : [];
    if (projects.length === 1) return "1 Project";
    if (projects.length > 1) {
      return `${projects.length} Projects`;
    }
    return null;
  };

  const getDepartmentMeta = (user) => {
    const departments = Array.isArray(user?.assigned_departments)
      ? user.assigned_departments
          .map((d) => (d?.department_name || "").trim())
          .filter(Boolean)
      : [];

    if (departments.length === 0) {
      return { text: null, tooltip: null };
    }
    if (departments.length <= 3) {
      return { text: departments.join(", "), tooltip: null };
    }

    const visibleDepartments = departments.slice(0, 3).join(", ");
    const remaining = departments.length - 3;
    return {
      text: `${visibleDepartments} +${remaining} more`,
      tooltip: departments.join(", "),
    };
  };

  const getUserMetaData = (user) => {
    const role = (user?.role || "").trim();
    const firstGroup = user?.assigned_group?.[0]?.group_name?.trim();
    const projectText = getUserProjectText(user);
    const departmentMeta = getDepartmentMeta(user);

    // Priority: Role -> Group -> Departments -> Projects
    const metadataParts = [role, firstGroup, departmentMeta.text].filter(Boolean);
    if (projectText) metadataParts.push(projectText);

    return {
      text: metadataParts.join(" \u2022 "),
      departmentTooltip: departmentMeta.tooltip,
    };
  };

  const filteredUsers = users.filter((user) => {
    const name = (user?.users_name || "").toLowerCase();
    const role = (user?.role || "").toLowerCase();
    const meta = getUserMetaData(user).text.toLowerCase();
    const query = userSearch.trim().toLowerCase();
    if (!query) return true;
    return name.includes(query) || role.includes(query) || meta.includes(query);
  });

  const filteredAccessWindows = userAccessWindows.filter((window) => {
    const user = users.find((item) => item.user_id.trim() === window.user_id);
    return (user?.users_name || "")
      .toLowerCase()
      .includes(accessWindowSearch.trim().toLowerCase());
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateRequiredFields()) return;

    // Format user access windows for API with correct field names
    const user_project = userAccessWindows.map((window) => ({
      user_id: window.user_id,
      access_start: window.access_start
        ? formatDate(window.access_start)
        : "",
      access_end: window.access_end
        ? formatDate(window.access_end)
        : "",
      equipment_group_ids: Array.isArray(window.equipment_group_ids)
        ? window.equipment_group_ids
        : [],
    }));

    const userData = {
      name: formData.name,
      client_name: formData.client_name,
      unit_name: formData.UnitName,
      description: formData.Description,
      start_date: formatDate(startDate), // Ensure date is in YYYY-MM-DD format
      end_date: formatDate(endDate),
      location: formData.location,
      timezone: formData.timezone,
      project_code: formData.project_code,
      client_code: formData.client_code,
      client_id: formData.client_id,
      work_order_id: formData.work_order_id,
      user_project: user_project,
      rating_config: formData.rating_config,
    };
    
    console.log("Payload to send:", userData);

    // ✅ FIX: Remove manual auth handling - let axiosInstance handle it
    try {
      const response = await axiosInstance.post(
        `/api/create_project`, // ✅ Removed API_URL prefix since it's in baseURL
        userData,
        // ✅ Removed manual headers - axiosInstance adds them automatically
      );
      console.log("Project creation response:", response.data);
      // ✅ Save new project ID (assuming backend returns it)
      const newProjectId = response.data?.project_id;

      if (newProjectId) {
        localStorage.setItem("selectedProject", JSON.stringify(newProjectId));
      }

      // ✅ Notify Sidebar to refresh
      window.dispatchEvent(
        new CustomEvent("projectCreated", {
          detail: { project_id: newProjectId },
        }),
      );

      setSnackbarMessage("Project created successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setError(null);
      setTimeout(() => {
        navigate("/Projects");
      }, 2000);
    } catch (err) {
      console.error("Project creation error:", err);

      let message =
        err.response?.data?.message ||
        "An error occurred while creating the project.";

      // Replace user ID with user name in error message
      if (message && users.length > 0) {
        const userIdRegex = /[a-f0-9-]{36}/g;
        const userIds = message.match(userIdRegex);

        if (userIds) {
          userIds.forEach((userId) => {
            const user = users.find((u) => u.user_id.trim() === userId.trim());
            if (user) {
              message = message.replace(userId, user.users_name.trim());
            }
          });
        }
      }

      setSnackbarMessage(message);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setError(message);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCancel = () => {
    window.history.back();
  };

  useEffect(() => {
    const prevBody = document.body.style.overflow;
    const prevHtml = document.documentElement.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevBody;
      document.documentElement.style.overflow = prevHtml;
    };
  }, []);

  return (
    <div
      className={`table-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      } project-form-screen`}
      style={{
        height: "calc(100vh - 100px)", // match your header height
        overflowY: "auto",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="form-titles">Create New Project</h4>
      </div>
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="">
                <div className="form-body">
                  <form onSubmit={handleSubmit}>
                    <div className="p-2">
                      {/* Project Details */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Name of Project{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                fieldErrors.name ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Name Of project"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              ref={setFieldRef("name")}
                              // required
                            />
                            {fieldErrors.name && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.name}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <FormControl
                              fullWidth
                              size="small"
                              error={!!fieldErrors.client_code}
                              ref={setFieldRef("client_code")}
                            >
                              <label className="form-label">
                                Client Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                value={formData.client_code || ""}
                                onChange={(event) => {
                                  const selectedCode = event.target.value;

                                  const selectedClient = clientCode.find(
                                    (client) =>
                                      String(client?.client_code) ===
                                      String(selectedCode),
                                  );

                                  setFormData((prev) => ({
                                    ...prev,
                                    client_code: selectedCode,
                                    client_name:
                                      selectedClient?.client_name || "",
                                    client_id: selectedClient?.client_id || "",
                                    location: selectedClient?.location || "",
                                    timezone: selectedClient?.timezone || "",
                                    project_code:
                                      selectedClient?.project_code || "",
                                  }));
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    client_code: "",
                                    client_name: "",
                                    timezone: "",
                                    project_code: "",
                                  }));
                                }}
                                displayEmpty
                                renderValue={(val) =>
                                  val
                                    ? val
                                    : isLoading
                                      ? "Loading..."
                                      : "Select Client Code"
                                }
                                input={
                                  <OutlinedInput
                                    className={
                                      fieldErrors.client_code
                                        ? "is-invalid"
                                        : ""
                                    }
                                  />
                                }
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      maxHeight: 200,
                                      overflowY: "auto",
                                      minWidth: "max-content",
                                      width: "auto",
                                      // let MUI handle positioning; removing this avoids odd clipping in some layouts
                                    },
                                  },
                                }}
                              >
                                <MenuItem disabled value="">
                                  {isLoading
                                    ? "Loading..."
                                    : "Select Client Code"}
                                </MenuItem>
                                {clientCode.length > 0 ? (
                                  clientCode.map((client) => (
                                    <MenuItem
                                      key={
                                        client.client_id ?? client.client_code
                                      }
                                      value={String(client.client_code ?? "")}
                                    >
                                      {`${client.client_code ?? ""} — ${
                                        client.client_name ?? ""
                                      }`}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>
                                    No client codes available
                                  </MenuItem>
                                )}
                              </Select>
                              {fieldErrors.client_code && (
                                <div className="invalid-feedback d-block">
                                  {fieldErrors.client_code}
                                </div>
                              )}
                            </FormControl>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Client Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                fieldErrors.client_name ? "is-invalid" : ""
                              }`}
                              placeholder="Client Name"
                              name="client_name"
                              value={formData.client_name}
                              ref={setFieldRef("client_name")}
                              readOnly
                            />
                            {fieldErrors.client_name && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.client_name}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Location"
                              name="location"
                              value={formData.location}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Timezone <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                fieldErrors.timezone ? "is-invalid" : ""
                              }`}
                              placeholder="Timezone"
                              name="timezone"
                              value={formData.timezone}
                              ref={setFieldRef("timezone")}
                              readOnly
                            />
                            {fieldErrors.timezone && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.timezone}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Project Code{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                fieldErrors.project_code ? "is-invalid" : ""
                              }`}
                              placeholder="Project Code"
                              name="project_code"
                              value={formData.project_code}
                              ref={setFieldRef("project_code")}
                              readOnly
                            />
                            {fieldErrors.project_code && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.project_code}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Work Order ID{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                fieldErrors.work_order_id ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Work Order ID"
                              name="work_order_id"
                              value={formData.work_order_id}
                              onChange={handleChange}
                              ref={setFieldRef("work_order_id")}
                              // required
                            />
                            {fieldErrors.work_order_id && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.work_order_id}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Unit Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                fieldErrors.UnitName ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Unit Name"
                              name="UnitName"
                              value={formData.UnitName}
                              onChange={handleChange}
                              ref={setFieldRef("UnitName")}
                            />
                            {fieldErrors.UnitName && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.UnitName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="mb-3 d-flex flex-column"
                            ref={setFieldRef("startDate")}
                          >
                            <label className="form-label">
                              Project Start Date:{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => {
                                setStartDate(date);
                                setFieldErrors((prev) => ({
                                  ...prev,
                                  startDate: "",
                                }));
                              }}
                              placeholderText="Select start date"
                              dateFormat="dd-MM-yyyy"
                              className={`form-control ${
                                fieldErrors.startDate ? "is-invalid" : ""
                              }`}
                             // required
                            />
                            {fieldErrors.startDate && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.startDate}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="mb-3 d-flex flex-column"
                            ref={setFieldRef("endDate")}
                          >
                            <label className="form-label">
                              Project End Date:{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => {
                                setEndDate(date);
                                setFieldErrors((prev) => ({
                                  ...prev,
                                  endDate: "",
                                }));
                              }}
                              placeholderText="Select end date"
                              dateFormat="dd-MM-yyyy"
                              className={`form-control ${
                                fieldErrors.endDate ? "is-invalid" : ""
                              }`}
                              minDate={startDate}
                             // required
                            />
                            {fieldErrors.endDate && (
                              <div className="invalid-feedback d-block">
                                {fieldErrors.endDate}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Description</label>
                            <textarea
                              className="form-control"
                              placeholder="Enter Description"
                              name="Description"
                              value={formData.Description}
                              onChange={handleChange}
                              rows={3}
                            />
                          </div>
                        </div>
                      </div>

                      {/* User In-Charge Section */}
                      <h5 className="mt-4">User In-Charge</h5>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <h6>Select users</h6>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <small
                              className="text-muted"
                              style={{
                                fontWeight: selectedUsers.length > 0 ? 600 : 500,
                                color: selectedUsers.length > 0 ? "#8F1D1D" : "#6b7280",
                              }}
                            >
                              {selectedUsers.length} selected
                            </small>
                          </div>
                          <input
                            type="text"
                            className="form-control form-control-sm mb-2"
                            placeholder="Search users..."
                            value={userSearch}
                            onChange={(e) => setUserSearch(e.target.value)}
                          />
                          <div
                            className={`border rounded p-3 project-user-list ${
                              fieldErrors.selectedUsers ? "border-danger" : ""
                            }`}
                            ref={setFieldRef("selectedUsers")}
                            style={{ maxHeight: "300px", overflowY: "auto" }}
                          >
                            {filteredUsers.length === 0 ? (
                              <p className="text-muted">No users available</p>
                            ) : (
                              filteredUsers.map((user, index) => {
                                const isSelected = selectedUsers.includes(
                                  user.user_id.trim(),
                                );
                                const isHovered = hoveredUserId === user.user_id;
                                const userMeta = getUserMetaData(user);

                                return (
                                <label
                                  key={user.user_id}
                                  htmlFor={`user-${user.user_id}`}
                                  className="d-flex align-items-start gap-2 px-2 py-2"
                                  style={{
                                    cursor: "pointer",
                                    borderRadius: "10px",
                                    marginBottom: index === filteredUsers.length - 1 ? 0 : 4,
                                    transition:
                                      "background-color 0.15s ease, box-shadow 0.15s ease",
                                    backgroundColor: isSelected
                                      ? "rgba(143, 29, 29, 0.10)"
                                      : isHovered
                                        ? "#f8fafc"
                                        : "#ffffff",
                                    boxShadow: isSelected
                                      ? "inset 0 0 0 1px rgba(143, 29, 29, 0.15)"
                                      : "inset 0 -1px 0 #f1f5f9",
                                  }}
                                  onMouseEnter={() => setHoveredUserId(user.user_id)}
                                  onMouseLeave={() => setHoveredUserId(null)}
                                >
                                  <input
                                    className="form-check-input mt-0"
                                    type="checkbox"
                                    id={`user-${user.user_id}`}
                                    checked={isSelected}
                                    onChange={() =>
                                      handleUserSelection(user.user_id.trim())
                                    }
                                    style={{ marginTop: 2, flexShrink: 0 }}
                                  />
                                  <div className="d-flex align-items-start flex-grow-1">
                                    <div style={{ minWidth: 0 }}>
                                    <span
                                      style={{
                                        display: "block",
                                        fontWeight: 600,
                                        color: "#1f2937",
                                        lineHeight: 1.2,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {user.users_name.trim()}
                                    </span>
                                    <span
                                      style={{
                                        display: "block",
                                        fontSize: "0.8rem",
                                        color: "#6b7280",
                                        marginTop: 2,
                                        lineHeight: 1.2,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      title={userMeta.departmentTooltip || undefined}
                                    >
                                      {userMeta.text}
                                    </span>
                                    </div>
                                  </div>
                                </label>
                              );
                              })
                            )}
                          </div>
                          {fieldErrors.selectedUsers && (
                            <div className="invalid-feedback d-block">
                              {fieldErrors.selectedUsers}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <h6>Access windows</h6>
                          <input
                            type="text"
                            className="form-control form-control-sm mb-2"
                            placeholder="Search selected users..."
                            value={accessWindowSearch}
                            onChange={(event) => setAccessWindowSearch(event.target.value)}
                          />
                          <div
                            className="border rounded p-3 project-access-window-list"
                            style={{ maxHeight: "300px", overflowY: "auto" }}
                          >
                            {userAccessWindows.length === 0 ? (
                              <p className="text-muted">No users selected.</p>
                            ) : filteredAccessWindows.length === 0 ? (
                              <p className="text-muted">No matching access windows.</p>
                            ) : (
                              filteredAccessWindows.map((window) => {
                                const user = users.find(
                                  (u) => u.user_id.trim() === window.user_id,
                                );
                                return (
                                  <div
                                    key={window.user_id}
                                    className="mb-3 p-3 border rounded bg-light project-access-card"
                                  >
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <strong>{user?.users_name.trim()}</strong>
                                      <Tooltip title="Remove User" arrow>
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger p-1"
                                          style={{
                                            lineHeight: 1,
                                            minWidth: "auto",
                                            height: "24px",
                                            width: "24px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "3px",
                                          }}
                                          onClick={() =>
                                            handleRemoveUser(window.user_id)
                                          }
                                          aria-label="Remove Person"
                                        >
                                          <X size={14} />
                                        </button>
                                      </Tooltip>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <label className="form-label small">
                                          Start date:&nbsp;
                                        </label>
                                        <DatePicker
                                          selected={
                                            window.access_start || startDate
                                          } // Added fallback to startDate
                                          onChange={(date) =>
                                            handleAccessWindowDateChange(
                                              window.user_id,
                                              "access_start",
                                              date,
                                            )
                                          }
                                          dateFormat="dd-MM-yyyy"
                                          className="form-control form-control-sm"
                                          placeholderText="Select start date"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label small">
                                          End date:&nbsp;
                                        </label>
                                        <DatePicker
                                          selected={
                                            window.access_end || endDate
                                          } // Added fallback to endDate
                                          onChange={(date) =>
                                            handleAccessWindowDateChange(
                                              window.user_id,
                                              "access_end",
                                              date,
                                            )
                                          }
                                          dateFormat="dd-MM-yyyy"
                                          className="form-control form-control-sm"
                                          placeholderText="Select end date"
                                          minDate={
                                            window.access_start || startDate
                                          }
                                        />
                                      </div>
                                      <div className="col-md-12 mt-2">
                                        <label className="form-label small">
                                          Equipment Groups:&nbsp;
                                        </label>
                                        <EquipmentGroupSelect
                                          options={equipmentGroupOptions}
                                          value={window.equipment_group_ids || []}
                                          onChange={(groupIds) =>
                                            handleUserEquipmentGroupsChange(
                                              window.user_id,
                                              groupIds,
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Rating Configuration */}
                      <h5 className="mt-4">Rating Configuration</h5>
                      <hr />
                      {formData.rating_config.map((config, index) => (
                        <div
                          className="row align-items-center mb-3"
                          key={index}
                        >
                          <div className="col-md-3">
                            <label className="form-label">Rating Value</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter rating value"
                              value={config.rating_value}
                              onChange={(e) => {
                                const updatedConfigs = [
                                  ...formData.rating_config,
                                ];
                                updatedConfigs[index].rating_value =
                                  e.target.value;
                                setFormData({
                                  ...formData,
                                  rating_config: updatedConfigs,
                                });
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Rating Type</label>
                            <FormControl fullWidth size="small">
                              <Select
                                value={config.type}
                                onChange={(e) => {
                                  const updatedConfigs = [
                                    ...formData.rating_config,
                                  ];
                                  updatedConfigs[index].type = e.target.value;
                                  setFormData({
                                    ...formData,
                                    rating_config: updatedConfigs,
                                  });
                                }}
                                displayEmpty
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      maxHeight: 200,
                                      overflowY: "auto",
                                      position: "absolute",
                                    },
                                  },
                                }}
                              >
                                <MenuItem value="" disabled>
                                  Select type
                                </MenuItem>
                                <MenuItem value="RF">RF</MenuItem>
                                <MenuItem value="RTJ">RTJ</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label d-block">
                              Select Color
                            </label>
                            <div className="d-flex align-items-center">
                              <input
                                type="color"
                                className="form-control form-control-color"
                                value={config.color_code}
                                onChange={(e) => {
                                  const updatedConfigs = [
                                    ...formData.rating_config,
                                  ];
                                  updatedConfigs[index].color_code =
                                    e.target.value;
                                  setFormData({
                                    ...formData,
                                    rating_config: updatedConfigs,
                                  });
                                }}
                              />
                              <span className="ms-2">{config.color_code}</span>
                            </div>
                          </div>
                          <div className="col-md-3 text-end">
                            {formData.rating_config.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => {
                                  const updatedConfigs =
                                    formData.rating_config.filter(
                                      (_, i) => i !== index,
                                    );
                                  setFormData({
                                    ...formData,
                                    rating_config: updatedConfigs,
                                  });
                                }}
                              >
                                Remove
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() =>
                          setFormData({
                            ...formData,
                            rating_config: [
                              ...formData.rating_config,
                              {
                                rating_value: "",
                                type: "",
                                color_code: "#000000",
                              },
                            ],
                          })
                        }
                      >
                        + Add Rating
                      </button>

                      {/* Buttons */}
                      <div className="d-flex justify-content-end mt-4 gap-2 project-form-actions">
                        <button
                          type="button"
                          className="btn project-form-btn project-form-btn-secondary"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn project-form-btn project-form-btn-primary"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Snackbar to display success or error message */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    </div>
  );
}


